var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715679578563,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1526,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M787.2 918.4c6.4 6.4 12.9 9.6 22.4 9.6s16-3.2 22.4-9.6l89.6-89.6c12.3-12.4 12.3-32.5-0.2-44.8-12.4-12.3-32.3-12.3-44.6 0l-35.2 35.2V620.8c0-17.7-14.4-32-32-32-19.2 0-32 12.9-32 32v198.4l-38.4-38.4c-12.3-12.4-32.4-12.5-44.8-0.2-12.4 12.3-12.5 32.4-0.2 44.8 0 0.1 0.1 0.1 0.2 0.2l92.8 92.8zM390.4 252.8c-28.8-28.8-73.7-35.2-108.8-22.4-35.2 16-57.6 54.4-57.6 92.8 0 51.2 41.6 92.8 92.8 92.8 38.4 0 76.8-22.4 92.8-57.6s6.4-76.8-19.2-105.6zM323.3 352c-19.2 0-35.2-12.9-35.2-28.8 0-9.6 3.2-16 9.6-22.4 3.2-9.6 12.9-12.8 22.4-12.8 16 0 32 12.8 32 28.8s-12.8 32-28.8 35.2z",
    fill: "#10a078",
    "p-id": 1527
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M896 96H128c-35.3 0.1-63.9 28.7-64 64v640c0.1 35.3 28.7 64 64 64.1h544V800H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h704c17.7 0 32 14.3 32 32v416h64V160c-0.1-35.3-28.7-63.9-64-64z",
    fill: "#10a078",
    "p-id": 1528
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.4 713.6c11.8 12.4 31.4 12.8 43.7 1.1 0.4-0.3 0.7-0.7 1.1-1.1l134.4-134.4 112 112c3.2 3.2 3.2 3.2 6.4 3.2 12.8 6.4 25.6 6.4 38.4-3.2l316.7-316.7c12.3-12.4 12.3-32.5-0.2-44.8-12.4-12.3-32.3-12.3-44.6 0L496 624 384 508.8l-3.2-3.2c-12.9-9.6-28.8-9.6-41.6 3.2l-160 160.1c-10.2 13.6-8.9 32.7 3.2 44.7z",
    fill: "#10a078",
    "p-id": 1529
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.871021640a5fd4f168e053612612e678.svg";
export { ForwardRef as ReactComponent };